import moment from "moment";
import {
  CheckboxField,
  Flex,
  Grid,
  SelectField,
  TextField,
} from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

const ServiceOrderSchedule = ({ form, type, onChange }) => {
  const onChangeInput = (e) => {
    let { name, value } = e.target;
    let valueMapped = value;

    if (name === "times") {
      valueMapped = Number(valueMapped);
      if (valueMapped <= 0) valueMapped = 1;
    }

    onChange(name, valueMapped);
  };

  const onChangeSerie = (e) => {
    let { checked } = e.target;
    onChange("serie", checked);
  };

  return (
    <>
      <div className="fs-5">{strings.title}</div>
      <Grid
        rowGap="15px"
        columnGap="15px"
        templateColumns={{ large: "1fr 1fr" }}
      >
        <TextField
          name="start"
          type="datetime-local"
          label={strings.fields.start.label}
          value={moment(form.start).format("YYYY-MM-DDTHH:mm:ss")}
          onChange={onChangeInput}
        />
        <TextField
          name="end"
          type="datetime-local"
          label={strings.fields.end.label}
          value={moment(form.end).format("YYYY-MM-DDTHH:mm:ss")}
          onChange={onChangeInput}
        />
        {type === "create" && form.start && form.end && (
          <Grid columnSpan={2}>
            <CheckboxField
              label={strings.fields.createSerie}
              value={form.serie}
              onChange={onChangeSerie}
            ></CheckboxField>
          </Grid>
        )}
      </Grid>
      {form.serie && (
        <Flex gap="10px" alignItems="center">
          <span style={{ whiteSpace: "nowrap" }}>
            {strings.fields.timeInterval.each}
          </span>
          <TextField
            name="times"
            type="number"
            value={form.times ?? 1}
            min={1}
            onChange={onChangeInput}
            width="75px"
          ></TextField>
          <SelectField
            name="timeInterval"
            value={form.timeInterval || ""}
            onChange={onChangeInput}
            width="150px"
          >
            {Object.entries(strings.fields.timeInterval.options).map((opt) => (
              <option value={opt[0]}>{opt[1]}</option>
            ))}
          </SelectField>
          <span style={{ whiteSpace: "nowrap" }}>
            {strings.fields.timeInterval.until}
          </span>
          <TextField
            name="until"
            type="date"
            value={form.until}
            onChange={onChangeInput}
          />
        </Flex>
      )}
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Programación",
    fields: {
      start: {
        label: "Fecha Inicio",
      },
      end: {
        label: "Fecha Final",
      },
      createSerie: "Crear serie",
      timeInterval: {
        each: "Repetir cada",
        until: "Hasta",
        options: {
          day: "Día/s",
          week: "Semana/s",
          month: "Mes/es",
          year: "Año/s",
        },
      },
    },
  },
});

export default ServiceOrderSchedule;
